import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import Launch from "./Launch";
import LaunchDefault from "./LanuchDefault";
import UploadDownload from "./UploadDownload";
import ReleaseNote from "./ReleaseNote";

const AdminFirmware = () => {
  return (
    <>
      <Tabs defaultActiveKey="lauch" className="mb-3">
        <Tab eventKey="lauch" title="launch" className="first">
          <Launch />
        </Tab>
        <Tab eventKey="lanuch-default" title="lanuch default" className="first">
          <LaunchDefault />
        </Tab>
        <Tab eventKey="upload-download" title="upload / download" className="first">
          <UploadDownload />
        </Tab>
        <Tab eventKey="release-note" title="release note" className="first">
          <ReleaseNote />
        </Tab>
      </Tabs>
    </>
  )
}

export default AdminFirmware;